<template>
  <div class="contion">
    <div v-show="tabValue == 1">
      <DressItem />
      <div class="height-auto"></div>
    </div>
    <div v-show="tabValue == 2">
      <WaterItem />
      <div class="height-auto"></div>
    </div>
    <div v-show="tabValue == 3">
      <ColorItem />
      <div class="height-auto" :style="{ backgroundColor: '#fff' }"></div>
    </div>
    <div v-show="tabValue == 4">
      <TimeItem />
    </div>
    <div v-show="tabValue == 5">
      <OrderItem />
    </div>
    <div class="tarbar">
      <div class="tarbar-list">
        <div class="tarbar-item" v-for="item in tabList" :key="item.name" @click="changeTar(item)">
          <img :src="item.value == tabValue ? item.avtiveUrl : item.url" />
          <div :style="{
            color: item.value == tabValue ? '#F19C9D' : 'rgba(0, 0, 0, 0.3)',
          }">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DressItem from "./dress.vue";
import WaterItem from "./water.vue";
import ColorItem from "./color.vue";
import TimeItem from "./time.vue";
import OrderItem from "./order.vue";
export default {
  name: "appIndex",
  components: { DressItem, WaterItem, ColorItem, TimeItem, OrderItem },
  data() {
    return {
      tabList: [
        {
          name: "妆容选择",
          value: 1,
          url: require("@/assets/妆容.svg"),
          avtiveUrl: require("@/assets/妆容1.svg"),
        },
        {
          name: "饮品选择",
          value: 2,
          url: require("@/assets/饮品.svg"),
          avtiveUrl: require("@/assets/饮品1.svg"),
        },
        {
          name: "色彩选择",
          value: 3,
          url: require("@/assets/画板.svg"),
          avtiveUrl: require("@/assets/画板1.svg"),
        },
        {
          name: "订单列表",
          value: 5,
          url: require("@/assets/order.png"),
          avtiveUrl: require("@/assets/order_active.png"),
        },
        {
          name: "服务计时",
          value: 4,
          url: require("@/assets/计时.svg"),
          avtiveUrl: require("@/assets/计时1.svg"),
        },
      ],
      tabValue: 1,
    };
  },
  methods: {
    changeTar(item) {
      this.tabValue = item.value;
    },
  },
};
</script>

<style scoped>
.contion {
  font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
  height: 100vh;
  overflow: auto;
}

.tarbar {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
}

.tarbar-list {
  background: #fff;
  display: flex;
  justify-content: space-around;
  padding: 10px;
}

.tarbar-item {
  cursor: pointer;
  text-align: center;
}

.tarbar-item img {
  width: 1.8em;
  height: 1.8em;
}

.tarbar-item>div {
  font-size: 12px;
}

.height-auto {
  height: 150px;
}
</style>
